// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".part-label-connector{box-sizing:border-box;position:absolute;left:0;right:0;bottom:0;top:0;border-radius:4px}.part-label-connector:hover:after{visibility:visible}[data-is-safari=true] .part-label-connector{border-radius:0!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
